module.exports = __webpack_public_path__ + "static/media/network_protocol.4cffb881.jpg";